import React from 'react';
import { PriceDisplay } from 'src/components/price-list/types';
import { PricePrice, CampaignMediaColors, Maybe, OfferPrices } from 'src/types';
import {
  StyledPriceLabel,
  PriceWrapper,
  StyledSecondaryPrice,
  PriceAndShipping,
  Wrapper,
  StyledBadge,
} from './styles';
import { getPriceLabelStyling } from 'src/components/offer/price/price-style';
import { PriceLabelStyleType } from '../types';
import { ShippingLabel } from '../shipping/shipping-label';
import { useAppContext } from '@prisjakt/ui-app-context';
import { CaptionText, FontEmphasis } from '@prisjakt/ui/text/variants';
import { getCompiledPriceData } from './price-data';
import { MediumUp } from 'src/ui/block';
import { usePriceRowContext } from 'src/areas/product/components/price-list/price-row-context';

interface IPriceLabel {
  price?: PricePrice | null;
  offerPrice?: OfferPrices | null;
  priceDisplay: PriceDisplay;
  featured: boolean;
  campaignColors?: Maybe<CampaignMediaColors>;
}

export const OfferPriceLabel: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<IPriceLabel>
>> = props => {
  const { price, offerPrice, campaignColors, priceDisplay, featured } = props;
  const { t, market } = useAppContext();
  const { forceMobileView } = usePriceRowContext();

  if (!price) {
    return null;
  }

  const priceData = getCompiledPriceData(
    price,
    offerPrice,
    priceDisplay,
    featured,
    t,
    market
  );

  return (
    <Wrapper>
      {priceData.label &&
        (priceData.isMemberPrice ? (
          <StyledBadge color="GREY_INVERTED" text={priceData.label} />
        ) : (
          <CaptionText emphasis={FontEmphasis.MEDIUM}>
            {priceData.label}
          </CaptionText>
        ))}
      <PriceAndShipping>
        {price && featured && !forceMobileView && (
          <MediumUp>
            <ShippingLabel
              price={price}
              offerPrice={offerPrice}
              priceDisplay={priceDisplay}
            />
          </MediumUp>
        )}

        <PriceWrapper>
          {priceData.secondaryPrice && (
            <StyledSecondaryPrice
              value={priceData.secondaryPrice}
              styling={PriceLabelStyleType.LIGHTEN}
            />
          )}
          {priceData.mainPrice && (
            <StyledPriceLabel
              value={priceData.mainPrice}
              styling={getPriceLabelStyling(Boolean(campaignColors), featured)}
            />
          )}
        </PriceWrapper>
      </PriceAndShipping>
    </Wrapper>
  );
};
